import React, { useEffect, useRef, useState } from "react";
import "./GenericChatbotContainer.css";
import iq_api_v2 from "../../../../services/iqApiV2";
import { useParams } from "react-router-dom";
import { useUser } from "../../../../context/UserContext";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchOpportunitiesRequest,
} from "../../../../store/features/actions/opportunities/opportunitesActions";
import {
  fetchWinOpportunitiesRequest,
} from "../../../../store/features/actions/opportunities/winOpportunitiesActions";
import SelectDropDownComp from "./selectDropDownComp";
import { useWebSocket } from "../../uiUtils/useWebSocket";
import { FetchSpotContactsRequest } from "../../../../store/features/actions/targetedReachout/spotContactsActions";
import { WSS_URL } from "../../../../config/apiConfig";
import PersonCardList from "./PersonCardList";
import PostSaveContainer from "./postSaveContainer/PostSaveContainer";
import { useTaskStatus } from "../../../../context/TaskStatusContext";
import GeneratingLoader from "../uiElements/GeneratingLoader";


const ChatContainerForContactAddSc = ({ onBack, type }) => {
  const { clientName, accountName } = useParams();
  const { user } = useUser();
  const dispatch = useDispatch();
  const containerRef = useRef(null);
  const textareaRef = useRef(null);
  const [flowType, setFlowType] = useState(null);
  const [chatMessages, setChatMessages] = useState([]);
  const [message, setMessage] = useState("");
  const [oppData, setOppData] = useState({ linkedin_url: "" });
  const [taskId, setTaskId] = useState(null);
  const [isSelected, setIsSelected] = useState([]);
  const isSelectedRef = useRef([]);
  const { registerTask, deregisterTask } = useTaskStatus();

  useEffect(() => {
    isSelectedRef.current = isSelected;
  }, [isSelected]);

  const { opportunitesData = [] } = useSelector((s) => s.opportunitiesReducer);
  const { winOpportunitesData = [] } = useSelector((s) => s.winOpportunitiesReducer);

  useEffect(() => {
    if (clientName && accountName && user?.id) {
      if (!opportunitesData.length)
        dispatch(fetchWinOpportunitiesRequest({ clientName, accountName, userId: user.id, type: "win" }));
      if (!winOpportunitesData.length)
        dispatch(fetchOpportunitiesRequest({ clientName, accountName, userId: user.id, type: "spot" }));
    }
  }, [clientName, accountName, user?.id]);

  useEffect(() => {
    textareaRef.current.style.height = "auto";
    textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
  }, [message]);

  useEffect(() => {
    containerRef.current.scrollTop = containerRef.current.scrollHeight;
  }, [chatMessages]);

  const handleToggleSelect = (person) => {
    setIsSelected((prev) =>
      prev.some((p) => p.id === person.id)
        ? prev.filter((p) => p.id !== person.id)
        : [...prev, person]
    );
  };

useWebSocket(taskId ? `${WSS_URL}/${taskId}` : null, (data) => {
  const people = data?.result?.people || [];
  const totalFound =  data?.result?.pagination?.total_entries ||data?.result?.people?.length

  // const totalFoundContacts = data?.result?.pagination?.total_entries;


  if (data?.status === "pending") {
    // If last message is not loading, add a new one. Else, update.
    // setChatMessages((prev) => {
    //   const last = prev[prev.length - 1];
    //   if (!last?.isLoading) {
    //     return [...prev, {
    //       sender: "SalesPlay",
    //       message: "⏳ Processing your request...",
    //       isLoading: true
    //     }];
    //   } else {
    //     return prev.map((msg, i) =>
    //       i === prev.length - 1 ? { ...msg, message: "⏳ Processing your request..." } : msg
    //     );
    //   }
    // });
    updateLastMessage( <div style={{maxHeight:"5rem", display:"flex",justifyContent:"center",alignItems:"center"}}><GeneratingLoader defaultFontSize="1rem"/></div>)
  }

  if (data?.status === "failed") {
    updateLastMessage("❗ Something went wrong while processing your request.");
  }
  

if (data?.status === "completed") {
  updateLastMessage(
    people?.length > 0 ? (
      <div>
        <PersonCardList people={people} isSelectedRef={isSelectedRef} dropDownData={[...opportunitesData, ...winOpportunitesData]} handleToggleSelect={handleToggleSelect} totalFound={totalFound}/>
        {/* {people.map((person) => (
          <PersonCard
            key={person.id}
            person={person}
            isSelected={isSelectedRef.current.some((p) => p.id === person.id)}
            onSelectChange={handleToggleSelect}
              dropDownData={[...opportunitesData, ...winOpportunitesData]}
          />
        ))}
       <div>Show More</div> */}
      </div>
    ) : (
      <>People Not Found. Please Retry</>
    )
  );
}

});


  const getTime = () => new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

  const pushMessage = (sender, content, isLoading = false) => {
    setChatMessages((prev) => [
      ...prev,
      { sender, message: content, isLoading, timestamp: !isLoading ? getTime() : undefined },
    ]);
  };

  const updateLastMessage = (newContent) => {
    setChatMessages((prev) => {
      const updated = [...prev];
      const last = updated.length - 1;
      updated[last] = { ...updated[last], message: newContent, isLoading: false, timestamp: getTime() };
      return updated;
    });
  };

  const initializeChat = () => {
    setFlowType(null);
    setChatMessages([
      {
        sender: "SalesPlay",
        message: (
          <>
            <div>{`Hi ${user?.firstname}! 👋 Would you like to find a Contact or add a new one?`}</div>
            <div className="find-opp-catagory-container">
              <button onClick={() => handleFlowSelection("find")} className="find-opp-catagory-container-btn">
                Find Contacts
              </button>
              <button onClick={() => handleFlowSelection("add")} className="find-opp-catagory-container-btn">
                Add Contact
              </button>
            </div>
          </>
        ),
        timestamp: getTime(),
      },
    ]);
  };

  const handleFlowSelection = (type) => {
    setFlowType(type);
    pushMessage("SalesPlay", type === "find" ? <>Great. Please describe your interest in 1–2 lines. <br/><br/>For Example:<br/>"Find contacts in strategy in Germany" </> : "Please enter the LinkedIn URL.");
  };

  const handleOpportunityApply = async (linkedin_url) => {
    pushMessage("SalesPlay", <div style={{maxHeight:"5rem", display:"flex",justifyContent:"center",alignItems:"center"}}><GeneratingLoader defaultFontSize="1rem"/></div>, false);
    try {
      const payload = {
        user_id: user?.id,
        linkedin_url,
        client:clientName,
        account:accountName
      }; 
      const res = await iq_api_v2.post("contact/add_contact_async", payload);
       
      if (res?.data) {
       const taskID = `${WSS_URL}/${res?.data?.task_id}`
       const addContactTask = user?.id+"_"+taskID;
       registerTask(addContactTask,taskID)
       updateLastMessage(<PostSaveContainer  onStop={()=>deregisterTask(addContactTask)} taskId={addContactTask} postAction={()=>dispatch(
        FetchSpotContactsRequest({
          clientName,
          accountName,
          userId: user?.id,
          type: "spot",
        })
      )}/>);    
    // pushMessage("SalesPlay", <PostSaveContainer  onStop={()=>deregisterTask(addContactTask)} taskId={addContactTask}/> || "Thanks. Contact has been added successfully.");
      }
     
    } catch (err) {
      updateLastMessage(`❗ ${err?.response?.data?.detail || "Something went wrong"}`);
    } finally {
      setMessage("");
      setOppData({ linkedin_url: "" });
      setChatMessages(prev => [...prev,
        {
          sender: "SalesPlay",
          message: (
            <>
              <div>{`Hi ${user?.firstname}! 👋 Would you like to find another Contact or add a new one?`}</div>
              <div className="find-opp-catagory-container">
                <button onClick={() => handleFlowSelection("find")} className="find-opp-catagory-container-btn">
                  Find Contact
                </button>
                <button onClick={() => handleFlowSelection("add")} className="find-opp-catagory-container-btn">
                  Add Contact
                </button>
              </div>
            </>
          ),
          timestamp: getTime(),
        },
      ]);
    }
  };
    function isValidLinkedInUrl(url) {
      const linkedInRegex = /^(?:https?:\/\/)?(?:www\.)?linkedin\.com\/in\/[a-zA-Z0-9-_]+\/?$/;
      return linkedInRegex.test(url.trim());
    }


  const handleUserInput = async (input) => {
    if (!input.trim()) return;
    pushMessage(user?.firstname || "User", input);
    setMessage("");

    if (flowType === "add" && !oppData.linkedin_url) {
      const linkedin = input.trim();
     

      if (isValidLinkedInUrl(linkedin)) {
         setOppData({ linkedin_url: linkedin });
             
              handleOpportunityApply(linkedin)
      }else{
         setOppData({ linkedin_url: null });
        pushMessage("SalesPlay", (
       <>Please Provide Correct LinkedIn URL</>
      ));
      }

    }

    if (flowType === "find") {
     
      try {
        const payload = { client: clientName, account: accountName, prompt: input, user_id: user?.id };
        const res = await iq_api_v2.post("contact/find_contacts", {}, { params: payload });
        
         pushMessage("SalesPlay", <div style={{maxHeight:"5rem", display:"flex",justifyContent:"center",alignItems:"center"}}><GeneratingLoader defaultFontSize="1rem"/></div>, false);
        if (res?.data?.task_id) setTaskId(res.data.task_id);
      } catch (err) {
        updateLastMessage(`❗ ${err?.response?.data?.message || "Something went wrong"}`);
      }
    }
  };

  const renderMessages = () =>
    chatMessages.map((msg, i) => {
      const isUser = msg.sender === user?.firstname;
      const showSender = i === 0 || chatMessages[i - 1].sender !== msg.sender;
      return (
        <div key={i} className={`message-wrapper ${isUser ? "align-right" : "align-left"}`}>
          {showSender && <p className="sender-name">{msg.sender}</p>}
          <div className={`message-bubble-${isUser ? "User" : msg.sender} ${msg.isLoading ? "is-loading" : ""}`}>
            <div className="message-content">{msg.message}</div>
            {!msg.isLoading && msg.timestamp && (
              <div className={`message-timestamp-${isUser ? "User" : msg.sender}`}>{msg.timestamp}</div>
            )}
          </div>
        </div>
      );
    });

  const handleBackAndReset = () => {
    setMessage("");
    setOppData({ linkedin_url: "" });
    setChatMessages([]);
    initializeChat();
    onBack();
  };

  useEffect(() => {
    initializeChat();
  }, []);

  return (
    <div className="chatbox-container">
      <div className="chatbox-header" onClick={handleBackAndReset}>
        <img className="back-btn-img" src="/img/back_top.png" alt="Back" />
        <span className="back_chat_top">Back</span>
      </div>
      <div className="chatbox-messages-container" ref={containerRef}>
        {renderMessages()}
      </div>
      <div className="chatbox-input-container">
        <textarea
          ref={textareaRef}
          className="chatbox-input"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyDown={(e) => {
              console.log("textarea", e);
              if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                handleUserInput(message.trim());
              }
            }}
          placeholder="Type here..."
        />
        <button className="send-button" onClick={() => handleUserInput(message)}>
          <img className="send-button-img" src="/img/arrow-up.png" alt="Send" />
        </button>
      </div>
    </div>
  );
};

export default ChatContainerForContactAddSc;